module.exports = __webpack_public_path__ + "static/media/materials.0cdf8068.jpg";